import React from 'react';
import { useProfile } from '../../hooks/useProfile';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isLoading } = useProfile();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-content-secondary">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;